import layouts from "../../layout";
import ObjectivesList from "../../views/apps/cmi/objetives/ObjectivesList.vue";
import Tasks from "../../views/apps/cmi/tasks/TaskList.vue";
import Perspective from "../../views/apps/cmi/perpectives/PerspectiveList.vue";
import DocumentList from "../../views/apps/cmi/documents/DocumentList";
// import GanttObjectives from "../../views/apps/cmi/gantt/GanttObjectives.vue";
import GanttMain from "../../views/apps/cmi/gantt/GanttMain.vue";
import ObjectivesReport from "@/views/apps/cmi/ObjectivesReport/ObjectivesReport";
import ProductivesHoursReport from "@/views/apps/cmi/ProductivesHoursReport/ProductivesHoursReport";
/*
import training from "../../views/apps/cmi/training/mview/index";
import store from "@/store";
import channelMview from "../../views/apps/cmi/training/mview/channelMview.vue";
import roles from "@/roles";
import { COMPANYS } from "@/const";
*/
//import kpiTask from "../../views/apps/cmi/tasks/kpiTaskTabs";
// import kpiTaskGanttTabs from "../../views/apps/cmi/tasks/kpiTaskGanttTabs";
//import DashBoardCmi from "@/views/apps/cmi/objetives/Dashboard.vue";
// import DashboardGantt from "@/views/apps/cmi/objetives/DashboardGantt.vue";
// import Reporte from "@/views/apps/cmi/objetives/Reporte.vue";
import AutoMVs from "@/views/apps/cmi/AutoMvs/AutoMVsReport.vue";
import ProductiveHoursReportByMonth from "@/views/apps/cmi/ProductiveHoursReportByMonth/ProductiveHoursReportByMonth.vue";

export default {
  path: "/cmi",
  name: "cmi",
  component: () =>
    import(/* webpackChunkName: "cmi" */ "../../views/apps/cmi/Cmi.vue"),
  meta: {
    auth: true
  },
  redirect: {
    name: "cmi-objectives-report"
  },
  children: [
    {
      path: "objectives-report",
      name: "cmi-objectives-report",
      // component: GanttObjectives,
      component: ObjectivesReport,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Objectives Report",
        tags: ["cmi", "ObjectivesReport"],
        index: true
      }
    },
    {
      path: "productives-hours-report",
      name: "cmi-productives-hours-report",
      // component: GanttObjectives,
      // Reporte de Horas productivas
      component: ProductivesHoursReport,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Reporte de Horas productivas",
        tags: ["cmi", "productives-hours-report"],
        index: true
      }
    },
    {
      path: "productives-hours-report-by-month",
      name: "cmi-productives-hours-report-by-month",
      // component: GanttObjectives,
      // Reporte de Horas productivas
      component: ProductiveHoursReportByMonth,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Reporte de Horas productivas por mes",
        tags: ["cmi", "productives-hours-report-by-month"],
        index: true
      }
    },
    {
      path: "GanttObjectives",
      name: "cmi-gantt",
      // component: GanttObjectives,
      component: GanttMain,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Gantt",
        tags: ["cmi", "GanttObjectives"],
        index: true
      }
    },
    {
      path: "AutoMVs",
      name: "cmi-AutoMVs",
      component: AutoMVs,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "AutoMV",
        tags: ["cmi", "AutoMVs"],
        index: true
      }
    },
    // Objectives
    {
      path: "objectives",
      name: "cmi-objectives",
      component: ObjectivesList,
      meta: {
        auth: true,
        searchable: true,
        title: "Objetivos",
        layout: layouts.navLeft,
        tags: ["Objetivos"],
        index: true
      }
    },
    // Tasks
    {
      path: "tasks",
      name: "cmi-tasks",
      component: Tasks,
      meta: {
        auth: true,
        searchable: true,
        title: "Tareas",
        layout: layouts.navLeft,
        tags: ["Task"]
      }
    },
    // perpectivas
    {
      path: "perspective",
      name: "cmi-perspective",
      component: Perspective,
      meta: {
        auth: true,
        searchable: true,
        title: "Perspectiva",
        layout: layouts.navLeft,
        tags: ["perspective"]
      }
    },
    {
      path: "documents",
      name: "cmi-documents",
      component: DocumentList,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Document",
        tags: ["cmi", "documents"],
        index: true
      }
    }
    // {
    //   path: "reporte",
    //   name: "cmi-dashboard",
    //   component: Reporte,
    //   // component: () =>
    //   //   import(
    //   //     "@/views/apps/cmi/objetives/Dashboard.vue"
    //   //   ),
    //   meta: {
    //     auth: true,
    //     searchable: true,
    //     layout: layouts.navLeft,
    //     title: "Reporte",
    //     index: true
    //   },
    //   children: [
    //     {
    //       path: "ReporteTareaGantt",
    //       name: "cmi-kpiTaskGantt",
    //       component: kpiTaskGanttTabs,
    //       meta: {
    //         auth: true,
    //         searchable: true,
    //         layout: layouts.navLeft,
    //         title: "Reporte Tarea Gantt",
    //         tags: ["objectives", "task"],
    //         index: true
    //       }
    //     },
    //     {
    //       path: "kpireporteGantt",
    //       name: "cmi-dashboardGantt",
    //       component: DashboardGantt,
    //       meta: {
    //         auth: true,
    //         searchable: true,
    //         layout: layouts.navLeft,
    //         title: "Kpi Reporte Gantt",
    //         index: true
    //       }
    //     }
    //     /*,
    //     {
    //       path: "ReporteTarea",
    //       name: "cmi-kpiTask",
    //       component: kpiTask,
    //       meta: {
    //         auth: true,
    //         searchable: true,
    //         layout: layouts.navLeft,
    //         title: "Reporte Tarea",
    //         tags: ["objectives", "task"],
    //         index: true
    //       }
    //     },
    //     {
    //       path: "kpireporte",
    //       name: "cmi-dashboard",
    //       component: DashBoardCmi,
    //       meta: {
    //         auth: true,
    //         searchable: true,
    //         layout: layouts.navLeft,
    //         title: "Kpi Reporte",
    //         index: true
    //       }
    //     }
    //     */
    //   ]
    // }
    // {
    //   path: "ReporteTarea",
    //   name: "cmi-kpiTask",
    //   component: () =>
    //         import(
    //           "../../views/apps/cmi/tasks/kpiTaskTabs"
    //         ),
    //   meta: {
    //     auth: true,
    //     searchable: true,
    //     layout: layouts.navLeft,
    //     title: "Reporte Tarea",
    //     tags: ["objectives", "task"],
    //     index: true
    //   }
    // },

    /*
    {
      path: "training",
      name: "training-cmi",
      component: training,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Entrenamientos",
        tags: ["training"],
        index: true,
        roles: [
          roles.SoporteVentas,
          roles.EjecutivoDeVentas,
          roles.CEO,
          roles.SuperUsuario
        ]
      },
      children: [
        {
          path: "cmi-link-channel-magynet",
          name: "cmi-training-link-channel-magynet",
          component: channelMview,
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "Canal de Youtube",
            tags: ["sales", "training", "channelMview"],
            index: true,
            roles: [
              roles.SoporteVentas,
              roles.EjecutivoDeVentas,
              roles.CEO,
              roles.SuperUsuario
            ],
            disable: store.state.user.user.CompanySelected !== COMPANYS.TB
          }
        }
      ]
    },
    */

    // {
    //   path: "dashboard",
    //   name: "cmi-dashboard",
    //   component: DashBoardCmi,
    //   meta: {
    //     auth: true,
    //     searchable: true,
    //     layout: layouts.navLeft,
    //     title: "Dashboard",
    //     index: true
    //   }
    // }
  ]
};
